import * as React from 'react';
import * as styles from './Thumbnails.css';
import { ResponsiveImage } from '../../../ResponsiveImage';
import { IProjectImage } from '../../../../types/builders';

export interface IThumbnailsProps {
  images: IProjectImage[];
  aspectRatio?: number;
}

export const Thumbnails: React.FC<IThumbnailsProps> = ({ images, aspectRatio }) => {
  return (
    <div className={styles['list']}>
      {images.map((image, i) => (
        <ResponsiveImage key={i} src={image.thumbnail} aspectRatio={aspectRatio} />
      ))}
    </div>
  );
};
